<!--用户下拉选择器-->
<template>
    <el-select
    v-model="uids"
    :multiple="isMany"
    reserve-keyword
    filterable
    remote
    clearable
    placeholder="请输入多个客户的完整名称"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="handleChange"
    size="small" 
    >
        <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
    </el-select>
</template>


<script>
import CommonService from "~/services/common";

export default {
    name: "CustomerSelectMultiple",
    props: {
        uid:false,//当前选择的uid
        disable:false,//禁止选择
        isMultiple: true
    },
    data() {
        return {
            //定义变量
            loading: true,
            uids: null,
            list: [],
            isMany: true //是否支持多个, 此处为了兼容外部传入组件内的值类型错误问题
        };
    },

    created: function() {
        if(typeof(this.uid) != 'undefined'){
            this.uids = this.uid;
        }
        if (this.isMultiple == true) {
            this.isMany = true;
        } else {
            this.isMany = false;
        }
        /** 如果加载了这个组件，应当进行初始化操作 */
        this.remoteMethod();
    },

    methods: {
        //远程搜索el-select远程获取方法。
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    let params = {
                        fields: 'id,name',
                        limit: 10,
                        name: query,
                        scenario:'all-user'
                    };
                    CommonService.getCustomerList(params).then(res => {
                        this.loading = false;
                        if (res.data) {
                            this.list = res.data.filter( item => {
                                if(!query) return true;
                                return item.name.toString().indexOf(query) > -1;
                            }).map(item => {
                                return {
                                    value: item.id,
                                    label: item.name
                                };
                            });
                        } else {
                            this.list = [];
                        }
                    });
                }, 200);
            } else {
                this.list = [];
            }
        },
        //select value值变化时触发
        handleChange(value) {
            this.$emit("change", value);
        },
        //对输入框进行重置
        reset(){
            this.uids = '';
            this.list = [];
        }
    },
}

</script>


// WEBPACK FOOTER //
// src/widgets/CustomerSelectMultiple.vue